module.exports = __webpack_public_path__ + "img/plus.4d6a10a6.svg";